const crypto = require('../crypto')

export default class Profile {
  constructor (source, q) {
    this.source = source
    this.q = q

    /**
     * Crea un nuevo perfil en el servidor
     * @param String appkey Llave publica de la aplicacion
     * @param Object body Objeto del contenido para crear
     * @returns {Q.Promise<Object>} Retornamos un objecto con la sesion creada con el usuario
     */
    this.CreateProfile = (appkey, body) => {
      const defer = this.q.defer()
      const explorer = this.source.GetClientInfo()
      body.os = explorer.os
      body.navegador = `${explorer.name}-${explorer.version}`
      body.password = crypto.GenerateHASH(body.password1)
      this.source.SendRequest('POST', 'profiles', { appkey }, body).then((rta) => {
        defer.resolve(rta)
      }).catch((err) => {
        defer.reject(err)
      })
      // retornamos la promesa
      return defer.promise
    }
    /**
     * Actualizar un perfil de usuario en el servidor
     * @param {String} userkey Llave publica del usuario
     * @param {Object} body Objeto del contenido para crear
     * @constructor
     */
    this.UpdateProfile = (userkey, body) => {
      const defer = this.q.defer()
      this.source.SendRequest('PUT', 'profiles', { userkey }, body).then((rta) => {
        defer.resolve(rta)
      }).catch((err) => {
        defer.reject(err)
      })
      // retornamos la promesa
      return defer.promise
    }
    /**
     * Obtiene un perfil junto con la info de la app
     * @param userkey
     * @param appkey
     * @constructor
     */
    this.GetProfile = (userkey, appkey) => {
      const defer = this.q.defer()
      this.source.SendRequest('GET', 'profiles', { publickey: userkey, appkey }).then((rta) => {
        defer.resolve(rta)
      }).catch((err) => {
        defer.reject(err)
      })
      return defer.promise
    }
  }
}
